/**
 * @flow
 * @relayHash 3c1864e09ddd59a550521241e1960d4d
 */

/* eslint-disable */

'use strict'

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UserManagementSignInInput = {|
  email: string,
  password: string,
  clientMutationId?: ?string,
|};
export type SignInMutationVariables = {|
  input: UserManagementSignInInput
|};
export type SignInMutationResponse = {|
  +userManagementSignIn: ?{|
    +success: ?boolean,
    +errors: ?$ReadOnlyArray<?{|
      +message: ?string,
      +errorCode: ?string,
    |}>,
    +token: ?string,
  |}
|};
export type SignInMutation = {|
  variables: SignInMutationVariables,
  response: SignInMutationResponse,
|};
*/

/*
mutation SignInMutation(
  $input: UserManagementSignInInput!
) {
  userManagementSignIn(input: $input) {
    success
    errors {
      message
      errorCode
    }
    token
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
    var v0 = [
            {
                kind: 'LocalArgument',
                name: 'input',
                type: 'UserManagementSignInInput!',
                defaultValue: null,
            },
        ],
        v1 = [
            {
                kind: 'LinkedField',
                alias: null,
                name: 'userManagementSignIn',
                storageKey: null,
                args: [
                    {
                        kind: 'Variable',
                        name: 'input',
                        variableName: 'input',
                    },
                ],
                concreteType: 'UserManagementSignInPayload',
                plural: false,
                selections: [
                    {
                        kind: 'ScalarField',
                        alias: null,
                        name: 'success',
                        args: null,
                        storageKey: null,
                    },
                    {
                        kind: 'LinkedField',
                        alias: null,
                        name: 'errors',
                        storageKey: null,
                        args: null,
                        concreteType: 'UserManagementError',
                        plural: true,
                        selections: [
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'message',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'errorCode',
                                args: null,
                                storageKey: null,
                            },
                        ],
                    },
                    {
                        kind: 'ScalarField',
                        alias: null,
                        name: 'token',
                        args: null,
                        storageKey: null,
                    },
                ],
            },
        ]
    return {
        kind: 'Request',
        fragment: {
            kind: 'Fragment',
            name: 'SignInMutation',
            type: 'Mutation',
            metadata: null,
            argumentDefinitions: (v0 /*: any*/),
            selections: (v1 /*: any*/),
        },
        operation: {
            kind: 'Operation',
            name: 'SignInMutation',
            argumentDefinitions: (v0 /*: any*/),
            selections: (v1 /*: any*/),
        },
        params: {
            operationKind: 'mutation',
            name: 'SignInMutation',
            id: null,
            text:
                'mutation SignInMutation(\n  $input: UserManagementSignInInput!\n) {\n  userManagementSignIn(input: $input) {\n    success\n    errors {\n      message\n      errorCode\n    }\n    token\n  }\n}\n',
            metadata: {},
        },
    }
})()
// prettier-ignore
;(node/*: any*/).hash = 'ba15b8d62ab4bca892da0ecd643cc65a';
module.exports = node
